import { Component } from '@angular/core';
import { AlertController, IonicPage, NavController, NavParams } from 'ionic-angular';
import { GruposProductosProvider } from '../../providers/gruposProductos/gruposProductos';
import { CompaniasProvider } from '../../providers/companias/companias';
import { ComandasProvider } from '../../providers/comandas/comandas';
import { Storage } from '@ionic/storage'


@IonicPage()
@Component({
  selector: 'page-carrusel-image',
  templateUrl: 'carrusel-image.html',
})
export class CarruselImagePage {
  images: string[]; // Definición del array de imágenes
  publicidad = []
  companiasId:any = null
  public datos = [];
  public datosReales = []
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public servicio: GruposProductosProvider,
    public servicioCompania:CompaniasProvider,
    public alertControllers: AlertController,
    public storage:Storage,
    public servicioComandas:ComandasProvider) {
      this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo','companiasId'])
      .then((val)=>{
        if(val){
          var valor = val['companiasId']
          this.companiasId = valor
          this.cargarPublicidad()
        }
      })
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CarruselImagePage');
  }

  goBack() {
    this.navCtrl.pop();
  }

  cargarPublicidad() {
    this.publicidad = []

    this.servicio.buscarPublicidad(this.companiasId)
    .subscribe(
      res => {
          this.publicidad =  JSON.parse(res['_body']).data[0]
        },
      err => {
        let alert = this.alertControllers.create({
          title: 'Error',
          subTitle: 'No se pudieron listar la publicidad, intente luego',
          buttons: ['Cerrar']
        });
        alert.present();
      }
    )
  }

  buscarComandas(){
    this.storage.get('companiasId').then((val)=>{
    this.servicioComandas.buscarComandasSinFacturarPorCompania(val)
      .subscribe((data)=>{
        this.agruparComandas(data,'S')
      },err =>{
        console.log(err)
      })
    })
  }

  agruparComandas(data:any, queHago:string){
    this.datosReales = []
    this.datos = []
    if(queHago=='S'){
      let bodyResponse = JSON.parse(data['_body'])
      let datosRealesResponse = bodyResponse.data[0]
      this.datosReales = datosRealesResponse
    }else{
      let bodyResponse = JSON.parse(data['_body'])
      let datosRealesResponse = bodyResponse.data[0]
      this.datosReales = datosRealesResponse
    }

    let recorrer = this.datosReales.length
      let valorNuevo = []
      let existe = 0
      let dondeVa = 0
      let posicionActualizar = 0

        for(let i=0;i<this.datosReales.length;i++){

        let codigoConsultar = this.datosReales[i].codigo
        dondeVa++

    if(this.datosReales[i].codigo === codigoConsultar){
      existe = 1
              if(this.datos.length== 0){
                let valores = {
                  cantidad : this.datosReales[i].cantidad,
                  codigo: this.datosReales[i].codigo,
                  nombreProducto: this.datosReales[i].nombreProducto,
                  imagen: this.datosReales[i].imagen,
                  color: this.datosReales[i].color,
                  numeromesa:this.datosReales[i].numeromesa == '200' ? this.datosReales[i].turno : this.datosReales[i].numeromesa,
                  comandasId: this.datosReales[i].comandasId,
                  id: 0,
                  primerNombre:this.datosReales[i].primerNombre,
                  direccion:this.datosReales[i].direccion,
                  descripcion:this.datosReales[i].descripcion
                }

                this.datos = [[{
                  cantidad : this.datosReales[i].cantidad,
                  codigo: this.datosReales[i].codigo,
                  nombreProducto: this.datosReales[i].nombreProducto,
                  imagen: this.datosReales[i].imagen,
                  color: this.datosReales[i].color,
                  numeromesa:this.datosReales[i].numeromesa == '200' ? this.datosReales[i].turno : this.datosReales[i].numeromesa,
                  comandasId: this.datosReales[i].comandasId,
                  id: 0,
                  primerNombre:this.datosReales[i].primerNombre,
                  direccion:this.datosReales[i].direccion,
                  descripcion:this.datosReales[i].descripcion
                }]]
            }else{
              let exists = 0
                let valorRealPosicion = 0
                let posicion = 0
                for(let y = 0; y < this.datos.length; y++ ){

                  if(this.datos[y][0]['codigo'] == codigoConsultar  ){
                    exists =  1
                    valorRealPosicion = y
                  }
                }
                if(exists !== 1){
                  let posicionnueva = this.datos.length
                  this.datos[posicionnueva] = [{
                    'cantidad' :  this.datosReales[i].cantidad,
                    'codigo' : this.datosReales[i].codigo,
                    'imagen': this.datosReales[i].imagen,
                    'id' : i,
                    'nombreProducto' : this.datosReales[i].nombreProducto,
                    'numeromesa':this.datosReales[i].numeromesa == '200' ? this.datosReales[i].turno : this.datosReales[i].numeromesa,
                    'color': this.datosReales[i].color,
                    'comandasId': this.datosReales[i].comandasId,
                    'primerNombre':this.datosReales[i].primerNombre,
                    'direccion':this.datosReales[i].direccion,
                    'descripcion':this.datosReales[i].descripcion
                }]
              }else{
                  this.datos[valorRealPosicion].push({
                    'cantidad' :  this.datosReales[i].cantidad,
                    'codigo' : this.datosReales[i].codigo,
                    'imagen': this.datosReales[i].imagen,
                    'id' : i,
                    'nombreProducto' : this.datosReales[i].nombreProducto,
                    'numeromesa':this.datosReales[i].numeromesa == '200' ? this.datosReales[i].turno : this.datosReales[i].numeromesa,
                    'color': this.datosReales[i].color,
                    'comandasId': this.datosReales[i].comandasId,
                    'primerNombre':this.datosReales[i].primerNombre,
                    'direccion':this.datosReales[i].direccion,
                    'descripcion':this.datosReales[i].descripcion
                  })
                }
              }
            }
          }
          // this.stopSound()
          const groupedData = this.datosReales.reduce((acc, current) => {
            // Verificar si el UUID ya está en el nuevo objeto
            if (!acc[current.Uuid]) {
              acc[current.Uuid] = current; // Si no está, agregarlo al nuevo objeto
            }
            return acc;
          }, {});
          const result = [];
          for (const key in groupedData) {
            result.push(groupedData[key]);
          }
          this.datosReales = result
  }

}



// WEBPACK FOOTER //
// ./src/pages/carrusel-image/carrusel-image.ts